import { useEffect } from 'react';

const useAdaBot = () => {
  useEffect(() => {
    const script = document.createElement('script');

    const applyAdaCallback = (event: StorageEvent) => {
      if (event.storageArea !== localStorage) {
        return;
      } else if (event.key === 'applyAdaToken' && event.newValue) {
        const parsed = JSON.parse(event.newValue);
        window.adaEmbed && window.adaEmbed.setSensitiveMetaFields(parsed);
      }
    };

    const onLoadCallback = () => {
      window.adaSettings = {
        adaReadyCallback: () => {
          // will not create duplicate listener if event listener is already present
          window.addEventListener('storage', applyAdaCallback);
        }
      }
    }

    script.src = 'https://static.ada.support/embed2.js';
    script.id = '__ada';
    script.onload = () => {
      onLoadCallback();
    }
    script.setAttribute('data-handle', 'bitpay');

    document.head.appendChild(script);

    return () => {
      // has no effect if listener isn't present
      window.removeEventListener('storage', applyAdaCallback);
      document.head.removeChild(script);
    }
  }, []);
};

export default useAdaBot;
